import { render } from "./SurveyRevision.vue?vue&type=template&id=1c282132&scoped=true"
import script from "./SurveyRevision.vue?vue&type=script&lang=js"
export * from "./SurveyRevision.vue?vue&type=script&lang=js"

import "./SurveyRevision.vue?vue&type=style&index=0&id=1c282132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c282132"]])

export default __exports__